import React, { useState } from 'react';
import { Table, Button, Tag } from 'antd';
import { constructColumn, constructColumnFilterSearch } from 'utils/table/table';
import { parentProductCategory } from 'utils/constants';

const TableComponent = ({ data, onSelectedProductCategory, loading }) => {
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleOnClickEditProductCategory = productCategory => {
    onSelectedProductCategory(productCategory);
  };

  const handleFilterChange = (pagination, filters) => {
    setSelectedFilters(filters.parent || []);
  };

  const filteredData = selectedFilters.length > 0 ? data.filter(record => selectedFilters.every(filter => record.parent.includes(filter))) : data;

  const columns = [
    {
      ...constructColumn('Category Name', 'name', { hasSorter: true }),
      ...constructColumnFilterSearch('name', 'Search Category Name'),
      render: (text, record) => {
        return (
          <Button type="link" onClick={() => handleOnClickEditProductCategory(record)}>
            {text}
          </Button>
        );
      }
    },
    {
      title: 'Parent Category',
      dataIndex: 'parent',
      key: 'parent',
      filters: parentProductCategory.map(cat => ({ text: cat.label, value: cat.value })),
      onFilter: (value, record) => {
        return true; // This will be handled in handleFilterChange
      },
      render: (text, record) => {
        if (record.parent.length > 0) {
          return (
            <div>
              {record.parent.map((parentId, index) => {
                // Find the corresponding category object from parentProductCategory
                const category = parentProductCategory.find(cat => cat.value === parentId);
                return category ? (
                  <Tag color="blue" key={index}>
                    {category.label}
                  </Tag>
                ) : null;
              })}
            </div>
          );
        } else {
          return '-';
        }
      }
    },
    {
      ...constructColumn('Number of Products', 'linkedProductCount', { hasSorter: true })
    }
  ];

  return <Table dataSource={filteredData} columns={columns} onChange={handleFilterChange} loading={loading} />;
};

export default TableComponent;
